module.exports = __webpack_public_path__ + "img/blog-3-pic-2.bca5b4bd.webp";